import { ImageType, TranslationItemModel } from '@/shared/api/BaseAPI.model'

type spiceLevelsModel = {
  id: string
  /**
   * 1-3, and the backend's own column, not this list's position. `getAll` has no
   * ORDER BY, so the order it comes back in is whatever Postgres feels like —
   * this is the only safe thing to map a rating onto.
   */
  level: number
  translations: TranslationItemModel[]
}

type dietsType = {
  id: string
  translations: TranslationItemModel[]
}

type dishModel = {
  id?: string
  price: number
  // VAT rate in percent (0-100)
  taxRate?: number
  // The list endpoint already carries the picture, so the table does not need a
  // request per row. Absent for a dish that has none.
  image?: ImageType
  priceToDishSizeId: {
    id: string
    price: number
  }[]
  ingredients: ReducedIngredientModel[]
  ingredientsByDishSizeId: IngredientByDishSizeIdModel[]
  menuNumber: number
  translations: TranslationItemModel[]
  dishToppingIds: string[]
  dishMenuTypeIds: string[]
  dishCategoryIds: string[]
  dishSizeIds: string[]
  allergenIds: string[]
  dietId: string | null
  spiceLevelId: string | null
}

type ReducedIngredientModel = {
  id: string
  unit: {
    id: string
    quantity: number
  }
}

type IngredientByDishSizeIdModel = {
  id: string
  ingredients: ReducedIngredientModel[]
}

/** POST /dishes answers with the created dish's id and nothing else. */
type dishCreatedModel = {
  id: string
}

type dishPayloadModel = {
  price: number | undefined
  // VAT rate in percent (0-100)
  taxRate?: number
  priceToDishSizeId: {
    id: string
    price: number
  }[]
  ingredients: ReducedIngredientModel[]
  ingredientsByDishSizeId: IngredientByDishSizeIdModel[]
  menuNumber: number
  translations: TranslationItemModel[]
  dishToppingIds: string[]
  dishMenuTypeIds: string[]
  dishCategoryIds: string[]
  dishSizeIds: string[]
  allergenIds: string[]
  dietId: string | null
  spiceLevelId: string | null
}

type dishPutPayloadModel = {
  dishId: string
  dishPayload: dishPayloadModel
}

type dishesResponseModel = dishModel[]
type dishResponseModel = dishModel

enum QUERY {
  DISHES = 'dishes',
  DISH_IMAGE = 'dishImage',
  SPICE_LEVELS = 'spiceLevels',
  DIETS = 'diets'
}
export { QUERY }

export type {
  dishModel,
  dishPayloadModel,
  dishCreatedModel,
  dishPutPayloadModel,
  dishesResponseModel,
  dishResponseModel,
  spiceLevelsModel,
  dietsType
}
